import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { projects } from '../../mockData';
import { Button } from '../ui/button';

const ProjectsSection = () => {
  const [activeFilter, setActiveFilter] = useState('Show All');

  const categories = [
    
  ];

  const filteredProjects =
    activeFilter === 'Show All'
      ? projects
      : projects.filter((project) => project.category.includes(activeFilter));

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <span className="text-yellow-500 font-semibold text-sm uppercase tracking-wider">Work of Excellence</span>
          <h2 className="text-4xl font-bold text-gray-800 mt-2">Recent Projects</h2>
        </div>

        {/* Filter Buttons */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setActiveFilter(category)}
              className={`px-6 py-2 font-semibold transition-all ${
                activeFilter === category
                  ? 'bg-yellow-500 text-white'
                  : 'bg-white text-gray-700 hover:bg-yellow-100 border border-gray-200'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProjects.map((project) => (
            <div
              key={project.id}
              className="group relative overflow-hidden bg-white shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              <div className="relative overflow-hidden h-64">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-yellow-500 transition-colors">
                  <Link to="/projects">{project.title}</Link>
                </h3>
                <p className="text-gray-600 text-sm">{project.category.join(', ')}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link to="/projects">
            <Button className="bg-yellow-500 hover:bg-yellow-600 text-white px-8 py-6 text-lg">
              View All Projects
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;